import { LearnTopicConfig } from "@/types/learn";

export const LEARN_TOPIC_REGISTRY: Record<string, LearnTopicConfig> = {
  "my-genies": {
    topic: "my-genies",
    articleSlug: "create-your-first-genie",
    widgetPrompt: "Can you walk me through creating and managing my Genies?",
    label: "Learn about Genies",
  },
  "knowledge-base": {
    topic: "knowledge-base",
    articleSlug: "add-knowledge-to-your-genie",
    widgetPrompt: "How do I add knowledge to my Genie so it answers accurately?",
    label: "Learn about Knowledge",
  },
  "voice-playground": {
    topic: "voice-playground",
    articleSlug: "try-your-genie-in-the-voice-playground",
    widgetPrompt: "How should I test my Genie in the Voice Playground before publishing?",
    label: "Learn about testing",
  },
  portals: {
    topic: "portals",
    articleSlug: "publish-via-a-portal",
    widgetPrompt: "How do I publish my Genie via a Portal and customise it?",
    label: "Learn about Portals",
  },
  conversations: {
    topic: "conversations",
    articleSlug: "read-your-conversations-and-insights",
    widgetPrompt: "How do I get the most out of the Conversations and Insights tabs?",
    label: "Learn about Conversations",
  },
  connections: {
    topic: "connections",
    articleSlug: "connect-a-phone-number",
    widgetPrompt: "How do I connect a phone number or other channel to my Genie?",
    label: "Learn about Connections",
  },
  branding: {
    topic: "branding",
    articleSlug: "brand-your-genie",
    widgetPrompt: "How do I brand my Genie so it looks like my company?",
    label: "Learn about Branding",
  },
};

export function getLearnTopic(topic: string): LearnTopicConfig | null {
  return LEARN_TOPIC_REGISTRY[topic] ?? null;
}
